import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";
import OrdersDetailsTable from "./orders_details";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

export default function OrdersDetailsDialog({ open, onClose, subOrder }) {
  const [loading, setLoading] = useState(false);

  // عند الفتح، أضف حركة تحميل بسيطة (يمكنك تعديلها لاحقًا لجلب بيانات من API)
  React.useEffect(() => {
    if (open) {
      setLoading(true);
      setTimeout(() => setLoading(false), 700); // محاكاة تحميل
    }
  }, [open]);

  // حساب الإجماليات
  const totalProducts = subOrder?.items?.length || 0;
  const totalQuantity =
    subOrder?.items?.reduce((sum, item) => sum + Number(item.quantity || 0), 0) || 0;
  const totalPrice =
    subOrder?.items?.reduce(
      (sum, item) => sum + Number(item.price || 0) * Number(item.quantity || 0),
      0
    ) || 0;

  return (
    <><Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        تفاصيل الطلب{typeof subOrder?.id !== "undefined" && ` - رقم: ${subOrder.id}`}
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: 200,
            }}
          >
            <CircularProgress color="info" />
          </div>
        ) : (
          <>
            <OrdersDetailsTable items={subOrder?.items || []} />
            {/* ملخص الإجماليات */}
            <MDBox
              mt={4}
              display="flex"
              justifyContent="center"
              alignItems="center"
              gap={4}
              sx={{
                background: "linear-gradient(90deg, #e0b15a, #ca9937)",
                borderRadius: 3,
                p: 2,
                boxShadow: 2,
              }}
            >
              <MDTypography variant="h6" color="white" fontWeight="bold">
                إجمالي المنتجات:{" "}
                <span style={{ color: "#fff", fontWeight: 700 }}>{totalProducts}</span>
              </MDTypography>
              <MDTypography variant="h6" color="white" fontWeight="bold">
                إجمالي الكمية:{" "}
                <span style={{ color: "#fff", fontWeight: 700 }}>{totalQuantity}</span>
              </MDTypography>
              <MDTypography variant="h6" color="white" fontWeight="bold">
                إجمالي السعر:{" "}
                <span style={{ color: "#fff", fontWeight: 700 }}>
                  {totalPrice.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </span>
              </MDTypography>
            </MDBox>
          </>
        )}
      </DialogContent>
    </Dialog>
      </>
  );
}
